const isMobile = userAgent => /Mobi/i.test(userAgent);
export default isMobile;
